import { lazy } from 'react';

export default {
    Communication: lazy(() => import("./core/communication")),
    DGraphQL: lazy(() => import("./core/dgraphql")),
}